<div class="container mt-3 g-0 px-3">
    <h2 class="text-center" i18n>Format d'export</h2>

    <div class="row align-items-center justify-content-center">
        <div class="col">
            <div class="h-100 my-2 p-3 border rounded-1 background-light">
                <!-- <mat-form-field class="col-3">
                    <input matInput [(ngModel)]="Model.Code" i18n-placeholder placeholder="Code" readonly>
                </mat-form-field> -->
                <div class="row align-items-center">
                    <div class="col-1"></div>
                    <mat-form-field class="col">
                        <mat-label>Nom de la configuration</mat-label>
                        <input matInput [(ngModel)]="Model.Name" i18n-placeholder placeholder="Name" required>
                    </mat-form-field>
                    <mat-slide-toggle class="col-1" [(ngModel)]="Model.IsActive" i18n>Actif!</mat-slide-toggle>
                </div>
            </div>
        </div>
    </div>

    <div class="row my-2">
        <div class="col">
            <div class="h-100 my-2 p-3 border rounded-1 background-light">
                <div class="row">

                    <h3 class="col-12 fst-italic" i18n>Couleurs des cellules</h3>
                    <div class="col-1"></div>
                    <div class="col-5">
                        <div class="row align-items-center">
                            <ngx-colors class="col-auto mx-1 d-inline-flex" [colorPickerControls]="'no-alpha'" ngx-colors-trigger format="hex" [(ngModel)]="Model.TestGroupForeColor"></ngx-colors>
                            <span class="col-auto align-super" i18n>Texte des groupes</span>
                        </div>
                        <div class="row align-items-center">
                            <ngx-colors class="col-auto mx-1 d-inline-flex" [colorPickerControls]="'no-alpha'" ngx-colors-trigger format="hex" [(ngModel)]="Model.TestGroupBackColor"></ngx-colors>
                            <span class="col-auto align-super" i18n>Fond des groupes</span>
                        </div>
                    </div>
                    <div class="col-1"></div>
                    <div class="col-5">
                        <div class="row align-items-center">
                            <ngx-colors class="col-auto mx-1 d-inline-flex" [colorPickerControls]="'no-alpha'" ngx-colors-trigger format="hex" [(ngModel)]="Model.TestForeColor"></ngx-colors>
                            <span class="col-auto align-super" i18n>Texte des tests</span>
                        </div>
                        <div class="row align-items-center">
                            <ngx-colors class="col-auto mx-1 d-inline-flex" [colorPickerControls]="'no-alpha'" ngx-colors-trigger format="hex" [(ngModel)]="Model.TestBackColor"></ngx-colors>
                            <span class="col-auto align-super" i18n>Fond des tests</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col h-100">
            <div class="h-100 my-2 p-3 border rounded-1 background-light">
                <div class="row">

                    <h3 class="col-12 fst-italic" i18n>Logo </h3>

                    <div class="row">
                        <div class="col-6 d-flex align-items-center justify-content-center uploadfilecontainer" (click)="fileInput4DnD.click()" appDragDrop
                            (onFileDropped)="onFileFromDragNDrop($event)">
                            <input type="file" #fileInput4DnD (change)="onFileFromDragNDrop($event.target)">
                            <mat-icon class="mx-1 material-symbols-outlined" aria-label="add-image ">cloud_upload</mat-icon> Choisir un fichier
                        </div>
                        @if (Model.LogoToBase64) {
                        <div class="col-6">
                            <img [src]="getBase64FromLogo()" />
                        </div>
                        }
                    </div>

                </div>
            </div>
        </div>
    </div>

    <div class="row align-items-center my-2">
        <div class="col">
            <div class="h-100 my-2 p-3 border rounded-1 background-light">
                <div class="row">

                    <h3 class="col-12 fst-italic" i18n>Visibilité de certains éléments</h3>
                    <div class="col-1"></div>
                    <div class="col-11">
                        <p>
                            <mat-slide-toggle class="" [(ngModel)]="Model.DisplayEmptyGroups" i18n>
                                Afficher les groupes vides
                            </mat-slide-toggle>
                        </p>
                    </div>
                    <div class="col-1"></div>
                    <div class="col-11">
                        <p>
                            <mat-slide-toggle class="" [(ngModel)]="Model.DisplayEmptyTests" i18n>
                                Afficher les tests vides
                            </mat-slide-toggle>
                        </p>
                    </div>
                    <div class="col-1"></div>
                    <div class="col-11">
                        <p>
                            <mat-slide-toggle class="" [(ngModel)]="Model.UseComaAsDecimalSeparator" i18n>
                                Virgule comme séparateur décimal
                            </mat-slide-toggle>
                        </p>
                    </div>
                    <div class="col-1"></div>
                    <div class="col-11">
                        <p>
                            <mat-slide-toggle class="" [(ngModel)]="Model.DisplayComparateurLQ" i18n>
                                Afficher le comparateur
                            </mat-slide-toggle>
                        </p>
                    </div>
                    <div class="col-1"></div>
                    <div class="col-11">
                        <p>
                            <mat-slide-toggle class="" [(ngModel)]="Model.DisplayDND" i18n>
                                Afficher D/ND
                            </mat-slide-toggle>
                        </p>
                    </div>
                    <div class="col-1"></div>
                    <div class="col-11">
                        <p>
                            <mat-slide-toggle class="" [(ngModel)]="Model.UseLeftMostLimit" i18n>
                                {{ Model.UseLeftMostLimit ? 'Couleur du seuil le plus à gauche si égalité des limites pour un paramètre' : 'Couleur du seuil le plus à droite si égalité des limites pour un paramètre' }}
                            </mat-slide-toggle>
                        </p>
                    </div>
                    <div class="col-1"></div>
                    <div class="col-11">
                        <p>
                            <mat-slide-toggle class="" [(ngModel)]="Model.HasBilanConformite" i18n>
                                Bilan de conformité
                            </mat-slide-toggle>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row align-items-center my-2">
        <div class="col">
            <div class="h-100 my-2 p-3 border rounded-1 background-light">
                <div class="row">

                    <h3 class="fst-italic" i18n>Police des dépassements de seuils</h3>
                    <div class="col-1"></div>
                    <div class="col-11">
                        <p>
                            <mat-slide-toggle class="" [(ngModel)]="Model.OutOfLimitFontBold" i18n>Gras</mat-slide-toggle>
                        </p>
                    </div>
                    <div class="col-1"></div>
                    <div class="col-11">
                        <p>
                            <mat-slide-toggle class="" [(ngModel)]="Model.OutOfLimitFontItalic" i18n>Italique</mat-slide-toggle>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row align-items-center my-2">
        <div class="col">
            <div class="h-100 my-2 p-3 border rounded-1 background-light">
                <div class="row">

                    <h3 class="fst-italic" i18n>Affichage en colonnes de certaines propriétés</h3>
                    <div class="col-1"></div>
                    <div class="col-11">
                        <p>
                            <mat-slide-toggle class="" [(ngModel)]="Model.WithLOQColumn" i18n>LOQ</mat-slide-toggle>
                        </p>
                    </div>
                    <div class="col-1"></div>
                    <div class="col-11">
                        <p>
                            <mat-slide-toggle class="" [(ngModel)]="Model.WithCASNumberColumn" i18n>CAS</mat-slide-toggle>
                        </p>
                    </div>
                    <div class="col-1"></div>
                    <div class="col-11">
                        <p>
                            <mat-slide-toggle class="" [(ngModel)]="Model.WithLOQIncertitudeColumn" i18n>Incertitude de la LOQ</mat-slide-toggle>
                        </p>
                    </div>
                    <div class="col-1"></div>
                    <div class="col-11">
                        <p>
                            <mat-slide-toggle class="" [(ngModel)]="Model.WithMethodColumn" i18n>Méthode</mat-slide-toggle>
                        </p>
                    </div>
                    <div class="col-1"></div>
                    <div class="col-11">
                        <p>
                            <mat-slide-toggle class="" [(ngModel)]="Model.WithParameterCodeColumn" i18n>Paramètre</mat-slide-toggle>
                        </p>
                    </div>

                </div>
            </div>
        </div>
    </div>

    <div class="row align-items-center my-2">
        <div class="col">
            <div class="h-100 my-2 p-3 border rounded-1 background-light">
                <div class="row">

                    <h3 class="fst-italic" i18n>Affichage en ligne de certaines propriétés</h3>
                    <div class="col-1"></div>
                    <div class="col-11">
                        <p>
                            <mat-slide-toggle class="" [(ngModel)]="Model.WithBarcodeRow" i18n>Code à barre</mat-slide-toggle>
                        </p>
                    </div>
                    <div class="col-1"></div>
                    <div class="col-11">
                        <p>
                            <mat-slide-toggle class="" [(ngModel)]="Model.WithPSVNameRow" i18n>Nom du PSV</mat-slide-toggle>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row align-items-center my-2">
        <div class="col">
            <div class="h-100 my-2 p-3 border rounded-1 background-light">
                <div class="row">

                    <h3 class="col-auto fst-italic mb-4" i18n> Groupe de matrices</h3>
                    <div class="col">
                        <button appPreventDoubleClick mat-mini-fab color="primary" class="col-auto text-center mx-1 mat-elevation-z0"
                            (throttledClick)="openProductDialog()">
                            <mat-icon class="material-symbols-outlined"> add_box </mat-icon>
                        </button>
                    </div>
                </div>

                @for (pg of Model.ProductGroupList; track pg.Code) {
                <div class="col-12 col-md-4 col-xl-3 ms-5">
                    <div class="h-100 m-1 p-3 border rounded-1 selected">
                        <div class="row">
                            <h4 class="col fw-bold">{{pg.Name}}</h4>
                            <button class="col-auto small-icon-button" mat-icon-button (click)="deleteProductGroup(pg)">
                                <mat-icon color="warn" class="material-symbols-outlined">delete</mat-icon>
                            </button>
                        </div>
                        <div class="row">
                            @for (p of pg.ElimsProductList; track p) {
                            <div>
                                <span class="col-auto  fw-bold">{{p.Eurodat5Code}} - {{p.ProductDescription}}</span>
                            </div>
                            }
                        </div>
                    </div>
                </div>
                }
            </div>
        </div>
    </div>

    <div class="row align-items-center my-2">
        <div class="col">
            <div class="h-100 my-2 p-3 border rounded-1 background-light">
                <div class="row">
                    <h3 class="col-12 fst-italic mb-3" i18n> Note personnelle</h3>
                    <div class="col-1"></div>
                    <ngx-editor-menu class="col-11" [editor]="editor!" [toolbar]="toolbar"> </ngx-editor-menu>
                    <div class="col-1"></div>
                    <ngx-editor class="col-10" [editor]="editor!" [(ngModel)]="Model.ExportNote" [disabled]="false" i18n-placeholder
                        placeholder="Votre note personnelle"></ngx-editor>
                    <div class="col-1"></div>
                </div>
            </div>
        </div>
    </div>

    <div class="row justify-content-end mt-3 ">
        <div class="col-6">
            <button appPreventDoubleClick class="w-100 " color="basic" mat-raised-button (throttledClick)="goBack()" i18n>
                Annuler
            </button>
        </div>
        <div class="col-6">
            <button appPreventDoubleClick class="w-100 white" color="accent" mat-raised-button (throttledClick)="save()" [disabled]="!CanSave()"
                i18n="{i18n_metadata}">
                {{ IsCreation ? 'Ajouter' : 'Modifier' }}
            </button>
        </div>
    </div>
</div>